import Box from "@mui/material/Box";
import TableDetail from "../../TableDetail/TableDetail";

const PreviewSentEmail = ({ detail = {} }) =>
<Box className="pt-4">
  <TableDetail
    detail={{
      status: detail.status,
      email: detail.email
    }}
  />
</Box>

export default PreviewSentEmail